import { z } from "zod";
import { TeamSchema } from "../../models/team.schema";

export const PrivateTeamControllerResponseSchema = {
  listTeams: TeamSchema.array(),

  getTeam: TeamSchema.nullable(),

  createTeam: TeamSchema,

  updateTeam: TeamSchema,

  deleteTeam: z.void(),
};
